import type { AlertHoverPayload } from '../alertHover.types'

export const alertHoverMocks: Record<string, AlertHoverPayload> = {
  1: {
    id: 'payment1',
    type: 'payment',
    body: {
      failed: 2,
      outstanding: 1,
    },
  },

  2: {
    id: 'agreements1',
    type: 'agreements',
    body: [
      { name: 'Silver membership agreement', date: 'Feb 1, 2021' },
      { name: 'Gold membership agreement', date: 'Jan 10, 2021' },
    ],
  },

  3: {
    id: 'forms1',
    type: 'forms',
    body: {
      pendingCount: 3,
    },
  },

  4: {
    id: 'notesProps1',
    type: 'notesProps',
    body: {
      notes: 1,
      properties: 3,
    },
  },

  5: {
    id: 'location1',
    type: 'location',
    body: {
      homeSiteName: 'Downtown Studio',
    },
  },

  6: {
    id: 'birthday1',
    type: 'birthday',
    body: { date: '16/08/1995' },
  },

  7: {
    id: 'packages1',
    type: 'packages',
    body: {
      membership: [
        { name: 'Gold Membership', used: 20 },
        { name: 'Silver Membership', used: 12 },
      ],
      credits: [
        { label: '20 Class Pack', left: 5 },
        { label: 'Private – TEN sessions', left: 2 },
      ],
    },
  },

  8: {
    id: 'firstSession1',
    type: 'firstSession',
    body: {
      clientName: 'Cecilia',
    },
  },

  9: {
    id: 'introOffers1',
    type: 'introOffers',
    body: ['Suffolk Park', 'Byron Bay'],
  },

  10: {
    id: 'suspended1',
    type: 'suspended',
    body: {
      reason: 'No valid membership or booking',
    },
  },
}

Object.values(alertHoverMocks).forEach((payload) => {
  if (!alertHoverMocks[payload.type]) {
    alertHoverMocks[payload.type] = payload
  }
})
